import './Premium.css'
import { IoMdCheckmark } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { IoMdClose } from "react-icons/io";
import logo from '../../resources/Frame 1.svg'
import logo_name from '../../resources/Logo.svg'

function Premium() {
    const navigate = useNavigate();

    const goToPage = (url) => {
        navigate(url);
    };

    function plan_type(name, monthly, description, benifits, middle, free, yearly_plan, url, trial_days) {
        return (
            <div className={(middle ? 'premium_plan_indiv_middle_div green_gradient' : 'premium_plan_indiv_side_div green_gradient_light') + ' premium_plan_indiv_div flex flex_column justify_space_between cursor_default'}>
                <div className='flex flex_column gap_20'>
                    <div className='flex flex_column gap_8'>
                        <div className='flex justify_space_between align_center'>
                            <h4 className={('white') + ' font_weight_500'}>{name}</h4>
                            {middle ? <p className='premium_plan_indiv_popular font_size_16'>Popular</p> : null}
                        </div>
                        {trial_days ? <p className='white'>{trial_days} Day free trial</p> : null}
                    </div>
                    <div className='flex flex_column'>
                        <p className={('white') + ' font_size_34 font_weight_500'}>$ {monthly} <span className={(middle ? 'premium_middle_gray' : 'premium_gray') + ' font_size_18'}>/month</span></p>
                        {yearly_plan ? <p className={'premium_plan_indiv_yearly_plan orange_3 font_size_14'}>{yearly_plan}</p> : null}
                    </div>
                    <p className={(middle ? 'premium_middle_gray' : 'premium_gray') + ' font_size_16'}>{description}</p>
                    <div className={middle ? 'premium_plan_indiv_divider_middle' : 'premium_plan_indiv_divider'}></div>
                    <div className='flex flex_column gap_12'>
                        {benifits.map((line, i) => (
                            <div key={i} className='flex gap_6 align_center'>
                                <IoMdCheckmark color={middle ? 'white' : '#e7e7e7'} />
                                <p className={(middle ? 'white' : 'white') + ((!free && i == 0) ? (middle ? ' premium_plan_indiv_bullet_underline_middle' : ' premium_plan_indiv_bullet_underline_side') : '') + ' font_size_16'}>{line}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <a href={url} className='text_decoration_none'>
                    <div className={(middle ? 'premium_plan_indiv_middle_button' : 'premium_plan_indiv_side_button green_gradient') + ' premium_plan_indiv_button text_align_center'}>
                        <p className={(middle ? 'green_1' : 'white') + ' font_size_20 cursor_pointer font_weight_500'}>{free ? 'Free' : 'Go Premium'}</p>
                    </div>
                </a>
            </div>
        )
    }

    return (
        <div className='premium_outmost_div white_gradient'>
            <div className='premium_close_button font_family_inter font_size_30 green_scale_1 cursor_pointer flex gap_10 align_center' onClick={() => {
                goToPage('/')
            }}>
                <img src={logo} />
                <img className="logo-icon" alt="" src={logo_name} />
            </div>
            <div className='premium_main_div flex flex_column align_center gap_50'>
                <div className='flex flex_column align_center gap_12 text_align_center'>
                    <h3 className='font_weight_600'>Unlock Unlimited Meal Plan With Premium</h3>
                    <p className='font_size_18'>Pick the plan that's best for you</p>
                </div>

                <div className='flex justify_center align_center gap_40 flex_wrap'>
                    <div>
                        {plan_type('Free Plan', '0.00', 'Get started with our Free Plan',
                            ['Access to 5 cuisines', 'Over 100 recipes', 'Track your water intake', 'Limited analytics', 'Ingredient tracker'],
                            false, true, '', '/sign-up'
                        )}
                    </div>
                    <div>
                        {plan_type('Premium Plan', '6.99', 'Premium Plan for a comprehensive meal planner',
                            ['All Basic Benefits', 'Access to all 30+ cuisines', 'Unlimited access to over 500 recipes ', '24/7 Personalized Nutritionist AI', 'Full access to analytics', 'AI meal analyzer'],
                            true, false, '', '/subscription?plan_id=1', 7
                        )}
                    </div>
                    <div>
                        {plan_type('Yearly Plan', '4.99', 'Yearly Plan for a comprehensive meal planner',
                            ['All Premium Plan Benefits'],
                            false, false, '$59.88 total (you are saving $24.00)', '/subscription?plan_id=2', 7
                        )}
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
}


export default Premium;